export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LightboxGallery.vue?vue&type=template&id=4c8588d4&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/LightboxGallery.vue?vue&type=template&id=4c8588d4&scoped=true&
// module id = 209
// module chunks = 0